import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="account-form"
export default class extends Controller {
  static targets = [
    "viewMode", "editMode", "btnEdit",
    "input", "error", "successMsg", "submitButton"
  ]
  static values = {
    endpoint: String,
    reloadOnSuccess: { type: Boolean, default: false }
  }

  connect() {
    this.inputTargets.forEach(input => {
      input.addEventListener("input", () => {
        input.classList.remove("field-invalid")
        const field = input.dataset.pf
        const errorEl = this.errorTargets.find(el => el.dataset.pe === field)
        if (errorEl) {
          errorEl.textContent = ""
          errorEl.classList.add("hidden")
        }
      })
    })
  }

  toggleEdit(e) {
    if (e) e.preventDefault()
    if (this.hasViewModeTarget) this.viewModeTarget.classList.add("hidden")
    if (this.hasEditModeTarget) this.editModeTarget.classList.remove("hidden")
    if (this.hasBtnEditTarget) this.btnEditTarget.classList.add("hidden")
  }

  cancelEdit(e) {
    if (e) e.preventDefault()
    if (this.hasViewModeTarget) this.viewModeTarget.classList.remove("hidden")
    if (this.hasEditModeTarget) this.editModeTarget.classList.add("hidden")
    if (this.hasBtnEditTarget) this.btnEditTarget.classList.remove("hidden")
    
    // reset form
    const form = this.hasEditModeTarget ? (this.editModeTarget.tagName === "FORM" ? this.editModeTarget : this.editModeTarget.querySelector("form")) : null
    if (form) form.reset()
    if (this.hasSuccessMsgTarget) this.successMsgTarget.classList.add("hidden")
    this._clearErrors()
  }

  async submit(e) {
    if (e) e.preventDefault()
    this._clearErrors()
    
    if (this.hasSuccessMsgTarget) this.successMsgTarget.classList.add("hidden")

    const btn = this.hasSubmitButtonTarget ? this.submitButtonTarget : null
    let originalText = ""
    if (btn) {
      originalText = btn.textContent
      btn.disabled = true
      btn.textContent = "Đang lưu..."
    }

    try {
      const form = this.hasEditModeTarget ? (this.editModeTarget.tagName === "FORM" ? this.editModeTarget : this.editModeTarget.querySelector("form")) : this.element
      const formData = new FormData(form)
      
      const res = await fetch(this.endpointValue, {
        method: "POST",
        headers: { "Accept": "application/json" },
        body: formData
      })
      const data = await res.json()

      if (res.status === 422 && data.errors) {
        this._showErrors(data.errors)
      } else if (data.success) {
        if (this.hasSuccessMsgTarget) this.successMsgTarget.classList.remove("hidden")
        if (this.reloadOnSuccessValue) {
          setTimeout(() => window.location.reload(), 1500)
        } else {
          form.reset()
          setTimeout(() => {
            if (this.hasSuccessMsgTarget) this.successMsgTarget.classList.add("hidden")
            this.cancelEdit()
          }, 2000)
        }
      }
    } catch (err) {
      alert("Lỗi kết nối. Vui lòng thử lại.")
    } finally {
      if (btn) {
        btn.disabled = false
        btn.textContent = originalText
      }
    }
  }

  _clearErrors() {
    this.errorTargets.forEach(el => {
      el.textContent = ""
      el.classList.add("hidden")
    })
    this.inputTargets.forEach(el => {
      el.classList.remove("field-invalid")
    })
  }

  _showErrors(errors) {
    Object.entries(errors).forEach(([field, msg]) => {
      const errorEl = this.errorTargets.find(el => el.dataset.pe === field)
      if (errorEl) {
        errorEl.textContent = msg
        errorEl.classList.remove("hidden")
      }
      const inputEl = this.inputTargets.find(el => el.dataset.pf === field)
      if (inputEl) {
        inputEl.classList.add("field-invalid")
      }
    })
  }
}
